<template>
  <div class="movie-page">
    <div class="page-bg"></div>

    <!-- 顶部 -->
    <div class="top-section">
      <div class="top-glow glow-1"></div>
      <div class="top-glow glow-2"></div>

      <van-nav-bar class="nav-bar" :title="$t('video.video')">
        <template #left>
          <div class="back-btn" @click="back()">
            <van-icon name="arrow-left" color="#fff" />
          </div>
        </template>
      </van-nav-bar>

      <div class="top-desc-card">
        <div class="top-title">{{ $t('video.video') }}</div>
        <div class="top-subtitle">Video Gallery</div>
      </div>
    </div>

    <!-- 分类 + 内容 -->
    <div class="tabs-panel">
      <van-tabs
        v-model="active"
        animated
        swipeable
        class="custom-tabs"
        @change="OnChange"
      >
        <van-tab
          v-for="(item, index) in videolitem"
          :key="index"
          :title="item.name"
          :name="item.key"
        >
          <div class="tab-content">
            <van-pull-refresh
              v-model="isLoading"
              @refresh="onRefresh"
              pulling-text="Sao chép nhanh quy trình thả xuống"
              loosing-text="Bản sao nhắc nhở của quá trình phát hành"
              loading-text="Loading"
              success-text="Refresh successful"
            >
              <div class="list-wrap">
                <van-list
                  v-model="loading"
                  :finished="finished"
                  :immediate-check="false"
                  :finished-text="$t('video.no_more')"
                  @load="onLoad"
                >
                  <div class="video-grid">
                    <div
                      class="video-card"
                      v-for="(v, key) in videolist"
                      :key="key"
                      @click="toPlayVideo(v.id)"
                    >
                      <div class="video-cover-wrap">
                        <img class="video-cover" :src="v.vod_pic" />
                        <div class="video-cover-mask"></div>
                        <div class="play-badge">
                          <van-icon name="play-circle-o" />
                        </div>
                      </div>

                      <div class="video-info">
                        <div class="video-title">{{ v.title }}</div>
                      </div>
                    </div>
                  </div>
                </van-list>
              </div>
            </van-pull-refresh>
          </div>
        </van-tab>
      </van-tabs>
    </div>
  </div>
</template>

<script>
import { Toast } from 'vant';

export default {
  data() {
    return {
      active: 0,
      isLoading: false,
      count: 0,
      loading: false,
      finished: false,
      refreshing: false,
      videolitem: [],
      videolist: [],
      page: 0
    };
  },
  methods: {
    getVideoClass() {
      this.$http({
        method: 'get',
        url: 'video_class'
      }).then(res => {
        this.videolitem = res.data || [];
      });
    },

    toPlayVideo(id) {
      if (!localStorage.getItem('token')) {
        this.$router.push({ path: '/Login' });
      } else {
        this.$router.push({ path: '/PlayVideo?id=' + id });
      }
    },

    back() {
      window.history.back();
    },

    getVideoList() {
      this.$http({
        method: 'get',
        data: {
          id: this.active,
          page: this.page
        },
        url: 'video_list'
      }).then(res => {
        const list = (res.data && res.data.data) || [];
        this.videolist = this.videolist.concat(list);
        this.count = res.data.count || 0;
        this.page++;
      });
    },

    onLoad() {
      this.getVideoList();
      const timer = setTimeout(() => {
        if (this.refreshing) {
          this.videolist = [];
          this.refreshing = false;
        }
        this.loading = false;
        if (this.videolist.length >= this.count) {
          this.finished = true;
        }
        if (this.finished) clearTimeout(timer);
      }, 500);
    },

    OnChange() {
      this.videolist = [];
      this.page = 0;
      this.count = 0;
      this.finished = false;
      this.loading = false;
      this.getVideoList();
    },

    onRefresh() {
      setTimeout(() => {
        this.finished = false;
        this.loading = true;
        this.videolist = [];
        this.page = 0;
        this.count = 0;
        this.onLoad();
        this.isLoading = false;
        Toast(this.$t("reservation.refresh"));
      }, 500);
    }
  },

  created() {
    this.getVideoClass();
    this.OnChange();
  }
};
</script>

<style lang="less" scoped>
.movie-page {
  position: relative;
  min-height: 100vh;
  padding-bottom: 110px;
  background:
    radial-gradient(circle at top, rgba(255, 221, 232, 0.9) 0%, rgba(255, 244, 247, 0.96) 28%, #fff 68%);
  overflow-x: hidden;
}

.page-bg {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  height: 300px;
  background: linear-gradient(135deg, #ff95ba 0%, #ff6f9e 38%, #f04d87 70%, #d73b88 100%);
  border-radius: 0 0 34px 34px;
  box-shadow: 0 12px 32px rgba(227, 92, 138, 0.18);
  pointer-events: none;
  z-index: 0;
}

/* 顶部 */
.top-section {
  position: relative;
  z-index: 2;
  padding-bottom: 18px;
  overflow: hidden;
}

.top-glow {
  position: absolute;
  border-radius: 50%;
  background: rgba(255, 255, 255, 0.12);
  pointer-events: none;
}

.glow-1 {
  width: 180px;
  height: 180px;
  right: -40px;
  top: -30px;
}

.glow-2 {
  width: 120px;
  height: 120px;
  left: -20px;
  top: 120px;
  background: rgba(255, 255, 255, 0.08);
}

.nav-bar {
  position: relative;
  z-index: 3;
  background: transparent !important;
}

::v-deep .van-nav-bar {
  background: transparent !important;
}

::v-deep .van-nav-bar::after {
  border: none !important;
}

::v-deep .van-nav-bar__content {
  height: 92px;
}

::v-deep .van-nav-bar__title {
  color: #fff;
  font-size: 34px;
  font-weight: 700;
}

.back-btn {
  width: 52px;
  height: 52px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  background: rgba(255, 255, 255, 0.14);
  backdrop-filter: blur(8px);
}

::v-deep .back-btn .van-icon {
  font-size: 28px !important;
}

.top-desc-card {
  position: relative;
  z-index: 3;
  margin: 8px 20px 0;
  padding: 20px 22px;
  border-radius: 24px;
  background: rgba(255, 255, 255, 0.16);
  backdrop-filter: blur(14px);
  box-shadow: 0 14px 30px rgba(162, 30, 85, 0.16);
}

.top-title {
  font-size: 34px;
  line-height: 1.2;
  font-weight: 700;
  color: #fff;
}

.top-subtitle {
  margin-top: 10px;
  font-size: 22px;
  color: rgba(255, 255, 255, 0.82);
}

/* tabs */
.tabs-panel {
  position: relative;
  z-index: 5;
  margin: 8px 16px 0;
  border-radius: 22px;
  overflow: hidden;
  background: rgba(255, 255, 255, 0.88);
  box-shadow: 0 10px 30px rgba(213, 117, 150, 0.1);
  border: 1px solid rgba(255, 206, 222, 0.52);
}

.custom-tabs {
  background: transparent;
}

::v-deep .van-tabs__nav {
  background: transparent;
}

::v-deep .van-tabs__wrap {
  height: 88px;
}

::v-deep .van-tab {
  color: #c85a84;
  font-size: 28px;
  font-weight: 700;
}

::v-deep .van-tab--active {
  color: #f25790;
}

::v-deep .van-tabs__line {
  bottom: 14px;
  height: 6px;
  border-radius: 999px;
  background: linear-gradient(90deg, #ff8cb3 0%, #f45e93 100%);
}

::v-deep .van-tabs__wrap--scrollable .van-tab {
  padding: 0 24px;
}

::v-deep .van-hairline--bottom::after {
  border-bottom-width: 0 !important;
}

.tab-content {
  padding: 14px 12px 20px;
  min-height: calc(100vh - 220px);
}

.list-wrap {
  padding-bottom: 20px;
}

.video-grid {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 14px;
  padding: 4px 2px 8px;
}

.video-card {
  border-radius: 22px;
  overflow: hidden;
  background: rgba(255, 255, 255, 0.92);
  box-shadow: 0 10px 26px rgba(213, 117, 150, 0.12);
  border: 1px solid rgba(255, 206, 222, 0.46);
  transition: all 0.2s ease;
}

.video-card:active {
  transform: scale(0.98);
}

.video-cover-wrap {
  position: relative;
  width: 100%;
  height: 34vw;
  min-height: 150px;
  max-height: 220px;
  overflow: hidden;
  background: #f3f3f3;
}

.video-cover {
  width: 100%;
  height: 100%;
  display: block;
  object-fit: cover;
}

.video-cover-mask {
  position: absolute;
  inset: 0;
  background: linear-gradient(180deg, rgba(255,255,255,0) 0%, rgba(0,0,0,0.12) 100%);
  pointer-events: none;
}

.play-badge {
  position: absolute;
  right: 12px;
  bottom: 12px;
  width: 42px;
  height: 42px;
  border-radius: 50%;
  background: rgba(255, 255, 255, 0.22);
  backdrop-filter: blur(8px);
  display: flex;
  align-items: center;
  justify-content: center;
  color: #fff;
  font-size: 24px;
}

.video-info {
  padding: 14px 14px 16px;
}

.video-title {
  font-size: 24px;
  line-height: 1.5;
  color: #5b3342;
  font-weight: 700;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  min-height: 72px;
}

::v-deep .van-pull-refresh__track .van-pull-refresh__head * {
  color: #8e5870;
  font-size: 26px;
}

@media (max-width: 375px) {
  .top-desc-card {
    margin: 6px 14px 0;
    padding: 18px 18px;
  }

  .top-title {
    font-size: 30px;
  }

  .top-subtitle {
    font-size: 20px;
  }

  ::v-deep .van-nav-bar__content {
    height: 82px;
  }

  .back-btn {
    width: 46px;
    height: 46px;
  }

  ::v-deep .back-btn .van-icon {
    font-size: 24px !important;
  }

  ::v-deep .van-tab {
    font-size: 24px;
  }

  .video-grid {
    gap: 10px;
  }

  .video-cover-wrap {
    height: 32vw;
    min-height: 130px;
  }

  .video-title {
    font-size: 22px;
    min-height: 66px;
  }

  .play-badge {
    width: 38px;
    height: 38px;
    font-size: 22px;
  }
}
</style>

<style lang="less" scoped>
.movie-page {
	min-height: 100vh;
	padding-bottom: calc(88PX + env(safe-area-inset-bottom));
	background:
		radial-gradient(120% 42% at 50% -8%, rgba(148, 98, 36, 0.32), transparent 56%),
		radial-gradient(70% 30% at 100% 18%, rgba(112, 36, 72, 0.2), transparent 62%),
		linear-gradient(180deg, #1a140f 0%, #100d13 36%, #0c0a10 100%);
	color: #efe6d6;
	font-family: "Plus Jakarta Sans", "PingFang SC", "Microsoft YaHei", sans-serif;
	overflow-x: hidden;
}

.page-bg,
.top-glow {
	display: none;
}

.top-section {
	padding-bottom: 4PX;
	background: linear-gradient(180deg, rgba(28, 20, 14, 0.72), rgba(28, 20, 14, 0));
}

.nav-bar,
::v-deep .van-nav-bar {
	background: transparent !important;
}

::v-deep .van-nav-bar__content {
	height: 52PX;
}

::v-deep .van-nav-bar__title {
	color: #f3d27a !important;
	font-size: 18PX !important;
	font-weight: 650;
}

.back-btn {
	width: 32PX;
	height: 32PX;
	border-radius: 8PX;
	background: rgba(255, 244, 214, 0.08);
	border: 1PX solid rgba(212, 175, 55, 0.28);
}

::v-deep .back-btn .van-icon {
	font-size: 16PX !important;
	color: #f3d27a !important;
}

.top-desc-card {
	margin: 2PX 16PX 10PX;
	padding: 12PX 14PX;
	border: 1PX solid rgba(244, 216, 131, 0.16);
	border-radius: 8PX;
	background: linear-gradient(180deg, rgba(255, 244, 214, 0.08), rgba(18, 14, 22, 0.4));
	box-shadow: 0 10PX 22PX rgba(0, 0, 0, 0.24), inset 0 1PX 0 rgba(255, 236, 196, 0.1);
}

.top-title {
	color: #f9eab8;
	font-size: 16PX;
	font-weight: 650;
}

.top-subtitle {
	margin-top: 4PX;
	color: rgba(249, 234, 184, 0.62);
	font-size: 12PX;
}

.tabs-panel {
	margin: 0;
	padding: 0 12PX 16PX;
	border: 0;
	border-radius: 0;
	background: transparent !important;
	box-shadow: none;
	overflow: visible;
}

::v-deep .van-tabs__wrap {
	height: 42PX;
	background: transparent;
}

::v-deep .van-tabs__nav {
	background: transparent;
}

::v-deep .van-tab {
	color: rgba(249, 234, 184, 0.55);
	font-size: 13PX;
	font-weight: 650;
}

::v-deep .van-tab--active {
	color: #f3d27a;
}

::v-deep .van-tabs__line {
	bottom: 6PX;
	width: 18PX;
	height: 2PX;
	border-radius: 8PX;
	background: linear-gradient(90deg, #fff1c8, #c9963a);
}

.tab-content {
	padding: 8PX 0 0;
	min-height: 0;
	background: transparent;
}

.video-grid {
	display: grid;
	grid-template-columns: repeat(2, minmax(0, 1fr));
	gap: 10PX;
}

.video-card {
	overflow: hidden;
	border: 1PX solid rgba(244, 216, 131, 0.16);
	border-radius: 8PX;
	background: linear-gradient(180deg, rgba(255, 248, 230, 0.07), rgba(18, 14, 22, 0.78));
	box-shadow: 0 8PX 18PX rgba(0, 0, 0, 0.22), inset 0 1PX 0 rgba(255, 236, 196, 0.06);
}

.video-info {
	padding: 0;
	background: transparent;
}

.video-cover-wrap {
	height: 118PX;
	min-height: 0;
	max-height: none;
	background:
		radial-gradient(circle at 50% 40%, rgba(243, 210, 122, 0.16), transparent 58%),
		#120e16;
}

.video-cover {
	width: 100%;
	height: 100%;
	object-fit: cover;
}

.video-cover-mask {
	background: linear-gradient(180deg, rgba(0, 0, 0, 0) 46%, rgba(8, 6, 12, 0.28) 100%);
}

.play-badge {
	right: 8PX;
	bottom: 8PX;
	width: 26PX;
	height: 26PX;
	border: 1PX solid rgba(243, 210, 122, 0.5);
	border-radius: 50%;
	background: rgba(12, 9, 14, 0.62);
	color: #f3d27a;
	font-size: 14PX;
}

.video-title {
	display: block;
	min-height: 0;
	padding: 8PX 10PX 10PX;
	overflow: hidden;
	color: #f6e7c0;
	font-size: 12PX;
	font-weight: 600;
	line-height: 1.4;
	white-space: nowrap;
	text-overflow: ellipsis;
	-webkit-line-clamp: unset;
	-webkit-box-orient: unset;
}

::v-deep .van-list__finished-text,
::v-deep .van-list__loading,
::v-deep .van-pull-refresh__head,
::v-deep .van-pull-refresh__track .van-pull-refresh__head * {
	color: rgba(249, 234, 184, 0.7);
	font-size: 12PX;
}
</style>
